// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___8Jdd7","inner":"styles__inner___16OtX"};